var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-error-message"},[(_vm.hasErrorMessage)?_c('div',{staticClass:"red"},[_vm._v(_vm._s(_vm.errMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }